module.exports = __webpack_public_path__ + "directory-big.png?cc09e495875123e99224d9fe55a45169";